// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1_tD6","detailsBorder":"styles_detailsBorder__2Wdx-"};